import { render } from "./HousesPage.vue?vue&type=template&id=fd219d74&scoped=true"
import script from "./HousesPage.vue?vue&type=script&lang=js"
export * from "./HousesPage.vue?vue&type=script&lang=js"

import "./HousesPage.vue?vue&type=style&index=0&id=fd219d74&scoped=true&lang=css"

import exportComponent from "/home/runner/work/Pacto_console/Pacto_console/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fd219d74"]])

export default __exports__